import React__default from 'react';
import { E as EditUserProfileProvider, a as EditUserProfile } from './index-10dad19d.js';
import './ui/Modal.js';
import 'react-dom';
import './index-a9101009.js';
import './LocalizationContext-a82461b5.js';
import './stringSet-b60e9529.js';
import './index-6add7940.js';
import './ui/Button.js';
import './index-6420013c.js';
import 'prop-types';
import './ui/Icon.js';
import './ui/IconButton.js';
import './_rollupPluginBabelHelpers-05128ded.js';
import './MediaQueryContext-d6110905.js';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './ui/Input.js';
import './ui/Avatar.js';
import './ui/ImageRenderer.js';
import './uuid-717930b4.js';
import './ui/TextButton.js';
import './color-91e43dce.js';
import './utils-e0c7329c.js';
import './actionTypes-ba87a2c9.js';
var EditProfile = function EditProfile(props) {
  var onEditProfile = props.onEditProfile,
    onCancel = props.onCancel,
    onThemeChange = props.onThemeChange;
  return /*#__PURE__*/React__default.createElement(EditUserProfileProvider, {
    onEditProfile: onEditProfile,
    onCancel: onCancel,
    onThemeChange: onThemeChange
  }, /*#__PURE__*/React__default.createElement(EditUserProfile, null));
};
export { EditProfile as default };